import * as ApiManager from './_manager';
import store from '../store';

export const files = {
  get: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files`,
      payload
    );
  },

  move: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/move`,
      payload
    );
  },

  duplicate: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/duplicate`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/update`,
      payload
    );
  },
  getDownloadUrl: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/get_download_url`,
      payload
    );
  },
  getPreviewUrl: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/get_preview_url`,
      payload
    );
  },

  setEncodingStatusRequested: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/files/${payload.id}/setEncodingStatusRequested`,
      payload
    );
  },
};
